import { render, staticRenderFns } from "./InsurerParticipants.vue?vue&type=template&id=d38ee400&scoped=true&"
import script from "./InsurerParticipants.vue?vue&type=script&lang=js&"
export * from "./InsurerParticipants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d38ee400",
  null
  
)

export default component.exports